import React from 'react';
import { Link } from 'react-router-dom';

const CourseCard = ({ course }) => {
  return (
    <div className="card p-6 h-full flex flex-col">
      <div className="aspect-w-16 aspect-h-9 mb-4">
        <img
          src={`https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=400&h=300&fit=crop&crop=center`}
          alt={course.title}
          className="w-full h-48 object-cover rounded-lg"
        />
      </div>
      
      <div className="flex-1 flex flex-col">
        <div className="flex items-center justify-between mb-2">
          <span className="px-3 py-1 bg-primary-100 text-primary-800 text-sm font-medium rounded-full">
            {course.level}
          </span>
        </div>

        <h3 className="text-xl font-bold text-gray-900 mb-2 line-clamp-2">
          {course.title}
        </h3>
        
        <p className="text-gray-600 mb-4 flex-1 line-clamp-3">
          {course.description}
        </p>

        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center text-sm text-gray-500">
            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            {course.duration}
          </div>
        </div>

        <div className="flex items-center justify-between">
          <div className="text-2xl font-bold text-primary-600">
            ${course.price}
          </div>
          <Link
            to={`/course/${course.id}`}
            className="btn-primary text-sm py-2 px-4"
          >
            Learn More
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
